import React from 'react'

const Legend = ({ legendItems = [] }) => {
    return legendItems ? (
        <div className="legend-container">
            {legendItems.map((l, i) => (
                <div key={i} className="legend-item">
                    <div
                        className="legend-color"
                        style={{
                            backgroundColor: l.color.fill,
                            border: `2px solid ${l.color.stroke ||
                                l.color.fill}`,
                        }}
                    />
                    <span className="legend-label">
                        {l.FacilityTypeDisplay}
                    </span>
                </div>
            ))}
        </div>
    ) : null
}

export default Legend
